"use strict";

angular.module("vendor")
.service("ReportService", function($resource, appConfig, FlashBag) {
    var dashboardResource = $resource(appConfig.API_SERVER + "/aws/quick-sight/vendor/dashboards/", {}, {
        get: {method: "GET", interceptor: {responseError: FlashBag.responseErrorInterceptor}}
    });
    var embedUrlResource = $resource(appConfig.API_SERVER + "/aws/quick-sight/vendor/embed-url/", {}, {
        get: {method: "GET", interceptor: {responseError: FlashBag.responseErrorInterceptor}}
    });

    this.getDashboards = function(openIdToken) {
        var params = {
            open_id_token: openIdToken
        };
        return dashboardResource.get(params);
    };

    this.getEmbedUrl = function(openIdToken, dashboardId) {
        var params = {
            open_id_token: openIdToken,
            dashboard_id: dashboardId
        };
        return embedUrlResource.get(params);
    };
});



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/report/reports.service.js
// module id = 892
// module chunks = 0